import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { Freshness } from '@/types/qriots';

interface FreshnessLabelProps {
  freshness: Freshness;
}

export function FreshnessLabel({ freshness }: FreshnessLabelProps) {
  const { t } = useTranslation('riot');
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(id);
  }, []);

  const ageSec = Math.max(0, Math.floor((now - Date.parse(freshness.fetchedAt)) / 1000));
  const label =
    ageSec < 10
      ? t('freshness.justNow')
      : ageSec < 60
        ? t('freshness.secondsAgo', { count: ageSec })
        : ageSec < 3600
          ? t('freshness.minutesAgo', { count: Math.floor(ageSec / 60) })
          : t('freshness.olderThanHour');

  return <span className="text-[10px] text-fg-muted">{label}</span>;
}
